import React from 'react';
import style from './Login.module.scss';
import LoginForm from './components/LoginForm/index';
import LoginFooter from './components/LoginFooter/index';

const Login = () => (
  <div className={style.loginPageBackground}>
    <div className={style.loginPageFormContainer}>
      <LoginForm />
    </div>
    <div className={style.loginPageFooter}>
      <LoginFooter />
    </div>
  </div>
);

export default Login;
